import { render, staticRenderFns } from "./TheLayoutMain.vue?vue&type=template&id=295ff0f8&scoped=true&"
import script from "./TheLayoutMain.vue?vue&type=script&lang=js&"
export * from "./TheLayoutMain.vue?vue&type=script&lang=js&"
import style0 from "./TheLayoutMain.vue?vue&type=style&index=0&id=295ff0f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295ff0f8",
  null
  
)

export default component.exports